import { NoRecordFoundV2 } from 'components/Common/Common'
import TextInputV2 from 'components/Common/TextInputV2'
import React from 'react'
import { Col, Row } from 'react-bootstrap'

function Step2({ data, values, setFieldValue }) {
    return (
        <div className='pe-lg-5'>
            <div style={{ marginTop: "15px" }}>
                <h5 className="profile-title">1. PROFILE INFORMATION</h5>
                <div className="d-flex flex-column gap-4">
                    <Row>
                        <Col md="5" className='d-flex gap-4'>
                            <TextInputV2
                                required
                                name="lastname"
                                label='Last Name'
                                value={values?.lastname}
                                onChange={(e) => setFieldValue("lastname", e.target.value)}
                                disabled 
                            />
                            <TextInputV2
                                required
                                name="firstname"
                                label='First Name'
                                value={values?.firstname}
                                onChange={(e) => setFieldValue("firstname", e.target.value)}
                                disabled 
                            />
                        </Col>
                        <Col md="4">
                            <TextInputV2
                                required
                                name="email"
                                label='Email' type='email'
                                value={values?.email}
                                disabled
                            />
                        </Col>
                        <Col md="3">
                            <TextInputV2
                                required
                                name="phone"
                                label='Phone Number'
                                type='number'
                                value={values?.phone}
                                onChange={(e) => setFieldValue("phone", e.target.value)}

                            />
                        </Col>
                    </Row> 
                   
                </div>
            </div>
 
            <div>
                <Col lg="12" className="" style={{ marginTop: "44px" }}>
                    <h5 style={{ marginTop: "16px" }} className="profile-title">2.   YOUR SCHOOLS FOR CLASSROOM REPORTS</h5>
                </Col>
                {
                    values?.assign_school?.length ? values?.assign_school?.map((item) => (
                        <Row>
                            <Col lg='4'>
                                <label className="discharge-screen-label">School Divisions</label><br />
                                <p className="discharge-screen-label mb-0" style={{ fontFamily: "Proxima Nova" }}>{item?.division_name}</p>
                            </Col>
                            <Col lg='4'>
                                <label className="discharge-screen-label">Schools</label><br />
                                {
                                    item?.schools?.map((list) => (
                                        <p className="discharge-screen-label mb-0" style={{ fontFamily: "Proxima Nova" }}>{list?.name}</p>
                                    ))
                                }
                            </Col>
                        </Row>
                    )) : <NoRecordFoundV2 />
                }

            </div>

        </div>
    )
}

export default Step2
